import React, { Component } from "react";

class InfoCard extends Component {
  // Parse inline formatting: **bold**, __underline__, *italic*, _italic_, [label](url)
  parseText = (text) => {
    if (typeof text !== "string") return text;

    const parts = text.split(
      /(\*\*.*?\*\*|__.*?__|_.*?_|\*.*?\*|\[.*?\]\(.*?\))/g,
    );

    return parts.map((part, index) => {
      // Bold: **text**
      if (part.startsWith("**") && part.endsWith("**")) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      // Underline: __text__
      if (part.startsWith("__") && part.endsWith("__")) {
        return <u key={index}>{part.slice(2, -2)}</u>;
      }
      // Italic: *text* or _text_
      if (
        (part.startsWith("*") && part.endsWith("*")) ||
        (part.startsWith("_") && part.endsWith("_"))
      ) {
        return <em key={index}>{part.slice(1, -1)}</em>;
      }
      // Link: [label](url)
      const linkMatch = part.match(/^\[(.*?)\]\((.*?)\)$/);
      if (linkMatch) {
        return (
          <a
            key={index}
            href={linkMatch[2]}
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkMatch[1]}
          </a>
        );
      }
      return part;
    });
  };

  renderContent = (item, index) => {
    if (!item) return null;

    // { bullets: [...] } → <ul>
    if (typeof item === "object" && item.bullets) {
      return (
        <ul key={index}>
          {item.bullets.map((bullet, bulletIndex) => (
            <li key={bulletIndex}>{this.parseText(bullet)}</li>
          ))}
        </ul>
      );
    }

    // { ordered: [...] } → <ol>
    if (typeof item === "object" && item.ordered) {
      return (
        <ol key={index}>
          {item.ordered.map((entry, i) => (
            <li key={i}>{this.parseText(entry)}</li>
          ))}
        </ol>
      );
    }

    // "---" → <hr />
    if (item === "---") {
      return <hr key={index} />;
    }

    // "# Heading" through "###### Heading" → <h1>–<h6>
    const headingMatch =
      typeof item === "string" && item.match(/^(#{1,6})\s+(.*)/);
    if (headingMatch) {
      const level = headingMatch[1].length;
      const Tag = `h${level}`;
      return <Tag key={index}>{this.parseText(headingMatch[2])}</Tag>;
    }

    // Plain string → <p>
    if (typeof item === "string") {
      return <p key={index}>{this.parseText(item)}</p>;
    }

    return null;
  };

  render() {
    const { title, chip, content = [] } = this.props;
    const style = {
      background: this.props.style,
    };

    return (
      <div className="card" style={style}>
        {chip && <span className="chip">{chip}</span>}
        {title && <h4 className="m-0">{title}</h4>}
        {Array.isArray(content) && content.map(this.renderContent)}
      </div>
    );
  }
}

export default InfoCard;
